export const importStatus = {
  IN_PROGRESS: 'En proceso',
  FINALIZED: 'Finalizado'
}
